export const RECRUIT = {
  INTERNSHIP: {
    JOB:
      '弊社の手掛けるアパレル、コスメをはじめとした様々なSNSマーケティング、プロモーション、メディア、イベント、パーティー等の業務の進行を行って頂きます。初めは、先輩社員に付きアシスタントとして業務をこなしながら成長して頂き徐々にお任せいたします。各プロジェクトごとにチームを結成し、本質的な問題解決をするため、戦略設計をして長期的な成功への基盤を築きます。代表がインターンから現在に至る背景を持つことから、インターンでも大きな裁量を持ち挑戦することが出来ます。自由度が高く、おしゃれで楽しい会社として個人個人が仕事を楽しみながら日々成長をしています。',
    REQUIREMENTS: {
      THEME:
        '英語カ不問 / 未経険OK / 学歴不問 / 未経験者OK / テレワークOK / 服装自由 / 勤務時間・給与相談OK',
      MANDATORY: [
        '○ 必須条件',
        '・各種学校の1・2年生（2年制の場合、1年生）',
        '・Word・Excel・PowerPointの基本作業できる方',
        '・週3日以上かつ合計で週15時間以上の動務可能な方 （時間、日数は応相談）',
        '・ファッション、美容などおしゃれに興味のある方',
        '・専門学生、短大生もOK',
      ],
      REQUEST: [
        '○ 歓迎する人物像',
        '・思いやりのある方',
        '・感謝の出来る方',
        '・自分の置かれている環境をより良い環境に出来る方',
        '・コミュニケーションが得意な方',
        '・流行を作る仕事に興味のある方',
        '・インターン経験を通じて、将来何かに貢献したい人',
      ],
    },
  },
  NEW_HIRE: {
    JOB:
      '弊社の手掛けるアパレル、コスメをはじめとした様々なSNSマーケティング、プロモーション、メディア、イベント、パーティー等の業務の進行を行って頂きます。初めは、先輩社員に付きアシスタントとして業務をこなしながら成長して頂き徐々にお任せいたします。各プロジェクトごとにチームを結成し、本質的な問題解決をするため、戦略設計をして長期的な成功への基盤を築きます。代表がインターンから現在に至る背景を持つことから、インターンでも大きな裁量を持ち挑戦することが出来ます。自由度が高く、おしゃれで楽しい会社として個人個人が仕事を楽しみながら日々成長をしています。',
    REQUIREMENTS: {
      THEME:
        '英語カ不問 / 未経険OK / 学歴不問 / 未経験者OK / テレワークOK / 服装自由 / 勤務時間・給与相談OK',
      MANDATORY: ['○ 必須条件', '・Word.Excel.PowerPointの基本作業できる方'],
      REQUEST01: [
        '○ 歓迎する人物像',
        '・IT系出身者',
        '・思いやりのある方',
        '・感謝の出来る方',
        '・自分の置かれている環境をより良い環境に出来る方',
        '・コミュニケーションが得意な方',
        '・流行を作る仕事に興味のある方',
        '・仕事を通じて社会に価値ある何かを創りたいと思ってる方',
      ],
      REQUEST02: [
        '・諦めが悪く負けず嫌いな方',
        '・自分のためだけでなく、他人の為に全力で努力出来る方',
        '・マーケティングに興味のある方',
        '・ファッションが好きな方',
        '・おしゃれなモノが好きな方',
        '・芸能に興味がある方',
        '・イケメン、美女が好きな方',
        '・エンジニアの方',
      ],
    },
  },
};

export const APPLICATION_DESCRIPTION =
  '履歴書を添付のうえ、下記住所もしくはメールアドレス宛にご連絡下さい。仕事内容や応募・条件に関する質問なども大歓迎です。ご応募お待ちしております。';

// ADDRESS: [
//   '〒150-0001',
//   '東京都渋谷区神宮前1－10－34',
//   '原宿セントラルプレイス2/3F',
//   '株式会社REROOTS 採用担当宛',
// ],
